import React from 'react';
import { Modal, Form, Radio, notification, Spin, DatePicker } from 'antd';
import moment from 'moment';
import { axius, images, types } from 'utils';

const StoreStatus = (props) => {
	const [form] = Form.useForm();

	const of = Form.useWatch('offlineFor', form);
	const [store, setVenue] = React.useState(props.store);
	const [visible, setVisible] = React.useState({ providers: [], status: '' });
	const [submitting, setSubmitting] = React.useState(false);
	const [customDateTime, setCustomDateTime] = React.useState(null);

	const hours = [
		{ label: '1 hour', value: 1 },
		{ label: '6 hours', value: 6 },
		{ label: '24 hours', value: 24 },
		{ label: 'Custom', value: 365 },
	];

	React.useEffect(() => {
		getData();
		// const orderTimer = setInterval(() => {
		// 	getData();
		// }, 120 * 1000);
		// return () => {
		// 	clearInterval(orderTimer);
		// };
		// eslint-disable-next-line
	}, []);

	React.useEffect(() => {
		if (props.store?.code) {
			setVenue(props.store);
		}
	}, [props.store]);

	React.useEffect(() => {
		if (visible.status === 'ACTIVE') {
			Modal.confirm({
				title: 'Turn store on',
				content:
					'Sure you want to turn this store back on before the set time elapses?',
				centered: true,
				okText: 'Turn on',
				onOk: () => {
					submit({ offlineFor: 0 });
				},
				onCancel: () => {
					setVisible({ providers: [], status: '' });
				},
			});
		}
		// eslint-disable-next-line
	}, [visible.status]);

	const getData = () => {
		axius.get(`stores/${store.code}`).then((res) => {
			if (res.status === 200) {
				setVenue(res.data);
				props.setVenue && props.setVenue(res.data);
			}
		});
	};

	const submit = (v) => {
		setSubmitting(true);
		if (of === 365 && customDateTime) {
			const diffInHours = Math.ceil(
				moment(customDateTime).diff(moment(), 'hours', true)
			);
			v.offlineFor = diffInHours;
		} else {
			v.offlineFor = +v.offlineFor;
		}

		axius
			.post(`omni/store-status`, { ...v, storeCode: store.code, ...visible })
			.then((res) => {
				setSubmitting(false);
				if (res.status === 201) {
					close();
					setVenue(res.data);
					notification.success({
						message:
							visible.status === 'ACTIVE'
								? 'Store Is Online'
								: 'Store Is Offline',
					});
					props.setVenue && props.setVenue(res.data);
				} else {
					setVisible({ providers: [], status: '' });
					notification.error({ ...res });
				}
			});
	};

	const close = () => {
		setVisible({ providers: [], status: '' });
		form.resetFields();
		setCustomDateTime(null);
	};

	return (
		<React.Fragment>
			<Spin spinning={submitting}>
				<div
					className={`bg-white px-2 py-2 rounded ${props.setVenue ? 'shadow' : ''}`}
				>
					<div className={`d-flex align-items-center`}>
						<img
							src={images.RepdashIcon}
							alt="RepDash"
							className={`${!store.preferences?.online ? 'grayscale' : ''} pointer mr-3 rounded-circle`}
							height={40}
							onClick={() =>
								setVisible({
									status: store.preferences?.online ? 'INACTIVE' : 'ACTIVE',
									providers: [types.OrdersOrigins.REPDASH],
								})
							}
						/>
						<img
							src={images.GlovoIcon}
							alt="Glovo"
							className={`${!store.preferences?.onlineOmni?.GLOVO ? 'grayscale' : ''} pointer mr-3`}
							height={40 - 3}
							onClick={() =>
								setVisible({
									status: store.preferences?.onlineOmni?.GLOVO
										? 'INACTIVE'
										: 'ACTIVE',
									providers: [types.OrdersOrigins.GLOVO],
								})
							}
						/>
						<img
							src={images.ChowdeckIcon}
							alt="Chowdeck"
							className={`${!store.preferences?.onlineOmni?.CHOWDECK ? 'grayscale' : ''} pointer`}
							height={40 - 3}
							style={{ borderRadius: '100%' }}
							onClick={() =>
								setVisible({
									providers: [types.OrdersOrigins.CHOWDECK],
									status: store.preferences?.onlineOmni?.CHOWDECK
										? 'INACTIVE'
										: 'ACTIVE',
								})
							}
						/>
					</div>
				</div>
			</Spin>

			<Modal
				open={!!(visible.status === 'INACTIVE' && visible.providers.length > 0)}
				width="450px"
				maskClosable={false}
				onCancel={close}
				footer={null}
				centered
			>
				<h5 className="m-0 font-weight-bold">Go Offline!</h5>
				<div className="divider mt-3 mb-3" />
				<Form form={form} layout="vertical" onFinish={submit}>
					<div>
						<h6>How long do you want to go offline for?</h6>
						<Form.Item
							name="offlineFor"
							rules={[{ required: true, message: 'Field is required' }]}
						>
							<Radio.Group className="d-block">
								{hours.map((hour) => (
									<Radio
										key={hour.label}
										value={hour.value}
										disabled={submitting}
									>
										{hour.label}
									</Radio>
								))}
							</Radio.Group>
						</Form.Item>
						{of === 365 && (
							<Form.Item
								label="Pick a specific end date & time"
								required
								help="Store will be offline until the selected date/time"
							>
								<DatePicker
									showTime={{
										format: 'HH:00',
										step: 60,
									}}
									disabled={submitting}
									disabledDate={(current) => current && current < moment()}
									onChange={(value) => {
										if (value) {
											const normalized = value.clone().minute(0).second(0);
											setCustomDateTime(normalized);
										} else {
											setCustomDateTime(null);
										}
									}}
									format="YYYY-MM-DD HH:mm"
									value={customDateTime}
									style={{ width: '100%' }}
									size="large"
								/>
							</Form.Item>
						)}
					</div>
					<p>&nbsp;</p>
					<div className="d-flex justify-content-between">
						<div>&nbsp;</div>
						<button
							className="btn btn-danger btn-lg"
							type="submit"
							disabled={submitting}
						>
							{submitting ? <i className="fa fa-spin fa-spinner" /> : ''} Save
						</button>
					</div>
				</Form>
			</Modal>
		</React.Fragment>
	);
};

export default StoreStatus;
